import { render, staticRenderFns } from "./NumMotion.vue?vue&type=template&id=7b6003d4&scoped=true&"
import script from "./NumMotion.vue?vue&type=script&lang=js&"
export * from "./NumMotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6003d4",
  null
  
)

export default component.exports